module.exports = __webpack_public_path__ + "img/pr-18.2d9d1b6f.png";